// extracted by mini-css-extract-plugin
export var columnTitle = "FooterTop-module--columnTitle--1fe04";
export var community = "FooterTop-module--community--10921";
export var footerTop = "FooterTop-module--footerTop--3c674";
export var link = "FooterTop-module--link--76738";